import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be59e95e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component-oc-submit" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "group" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "desc" }
const _hoisted_7 = { class: "form-wrapper" }
const _hoisted_8 = { class: "group" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "desc" }
const _hoisted_11 = { class: "form-wrapper" }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = { class: "input-value" }
const _hoisted_14 = { class: "scan-box" }
const _hoisted_15 = { class: "group" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "desc" }
const _hoisted_18 = {
  key: 0,
  class: "desc primary"
}
const _hoisted_19 = { class: "form-wrapper barcode" }
const _hoisted_20 = { class: "barcode-box" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "scan-box" }

import { onMounted, reactive, ref, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute, useRouter } from 'vue-router';
  import { Collection } from '@/stores';
  import { request, confirm } from '@/utils';
  import { FormItemOption } from '@/types/form';
  import { IUser } from '@/types/user';
  import { useToast } from 'bootstrap-vue-3';
  import { IOfflineCollection, getOfflineCollectionDefaultData } from '@/types/offline-collection';
  import { ColorVariants } from '@/constants';

  interface IProps {
    type: 'PDO' | 'OfflineCollection';
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as {
    type: 'PDO' | 'OfflineCollection';
  }

  
  const replaceNameMap = {
    'PDO': 'pdo.submission-new-submitted',
    'OfflineCollection': 'mine.offline_collections.detail.submission'
  };

  const { t } = useI18n();
  const route = useRoute();
  const toast = useToast();
  const store = Collection.create<Collection>({
    fetch(params = {}) {
      const body = {
        ...params,
        target_id_eq: route.params.id,
        target_type_eq: props.type,
        page: 0
      };
      return request.get('/mine/collection_bins', { params: body });
    }
  });
  const collectionBinId = ref();
  const member = reactive<IUser>({});
  const barcodes = reactive<string[]>(['']);
  const selectOptions = reactive<FormItemOption[]>([]);
  const ocInfo = reactive<IOfflineCollection>(getOfflineCollectionDefaultData());
  const currentMemberQrcode = ref();

  const remainingNumber = computed(() => {
    return member.remaining_number_of_barcodes;
  });
  const remainingNumberTips = computed(() => {
    if (remainingNumber.value === null) {
      return '';
    }
    return t('remaining_number_tips', { num: remainingNumber.value });
  });
  async function getOcInfo() {
    const { data } = await request.get<IOfflineCollection>(`offline_collections/${route.params.id}`);
    Object.assign(ocInfo, data);
  }

  onMounted(async () => {
    if (props.type === 'OfflineCollection') {
      getOcInfo();
    }
    await store.fetchData();
    store.data.forEach(item => {
      selectOptions.push({
        text: item.name,
        value: item.id
      });
    });
    collectionBinId.value = String(selectOptions[0].value);
  });

  async function updateMember(result: string) {
    const userId = result.split('tracking_code=')[1];
    if (!userId) {
      toast.show({ title: t('Tips'), body: t('offline_collection.form.Membership code is invalid') }, { variant: 'warning' });
      return;
    }
    const { data } = await request.get<IUser>('/user/user_info', { params: {
      user_id: userId,
      collection_bin_id: collectionBinId.value
    } });
    Object.assign(member, data);
    currentMemberQrcode.value = result;
    checkJoinedProgram();
  }

  async function checkJoinedProgram() {
    if (props.type !== 'OfflineCollection' || member.joined_program) {
      return;
    }
    await confirm('', { content: t('participate_join_content') });
    const bin = store.data.find(item => item.id === Number(collectionBinId.value));
    await request.post(`programs/${bin.program_id}/participate`, { user_id: member.id });
    updateMember(currentMemberQrcode.value);
    toast.show({ title: t('Success'), body: t('participate_join_success') }, { variant: ColorVariants.success });
  }


  function handleSelectChange() {
    Object.keys(member).forEach(key => {
      member[key] = null;
    });
  }

  function handleBarcodeChange(index: number, code: string) {
    barcodes[index] = code;
  }

  function handleAddMoreBarcode() {
    const num = barcodes.filter(v => v.trim()).length;
    if (props.type === 'OfflineCollection' && remainingNumber.value !== null && Number(remainingNumber.value) <= num) {
      toast.show({ title: t('Tips'), body: remainingNumberTips }, { variant: 'warning' });
      return;
    }
    barcodes.push('');
  }

  const router = useRouter();
  async function handleSubmit() {
    const bin = store.data.find(v => Number(v.id) === Number(collectionBinId.value));
    const params = {
      collection_bin_id: collectionBinId.value,
      user_id: member.id,
      program_id: bin.program_id,
      is_offline_collection: props.type === 'OfflineCollection',
      barcodes: barcodes.filter(Boolean)
    };
    if (!params.user_id) {
      toast.show({ title: t('Tips'), body: t('offline_collection.form.Please scan the membership code') }, { variant: 'warning' });
      return;
    }
    await checkJoinedProgram();
    if (!params.barcodes.length) {
      toast.show({ title: t('Tips'), body: t('offline_collection.form.Please add barcode') }, { variant: 'warning' });
      return;
    }
    await request.post('/user_requests/oc_collection_request', params);
    router.replace({ name: replaceNameMap[props.type], params: route.params, query: route.query });
  }

return (_ctx: any,_cache: any) => {
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_AppIconScan = _resolveComponent("AppIconScan")!
  const _component_AppScanner = _resolveComponent("AppScanner")!
  const _component_b_form_input = _resolveComponent("b-form-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(route).query.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(t)('offline_collection.step_index', { index: 1 })), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('offline_collection.form.Collected Bin QR code')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_b_form_select, {
          modelValue: collectionBinId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((collectionBinId).value = $event)),
          options: _unref(selectOptions),
          onChange: handleSelectChange
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(t)('offline_collection.step_index', { index: 2 })), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('offline_collection.form.Scan membership code')), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(member).screen_name), 1),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_AppScanner, {
              onChange: _cache[1] || (_cache[1] = ($event: any) => (updateMember($event as any)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIconScan)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("h3", _hoisted_16, _toDisplayString(_unref(t)('offline_collection.step_index', { index: 3 })), 1),
      _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('offline_collection.form.Scan QR barcode on the collected item')), 1),
      (props.type === 'OfflineCollection' && _unref(remainingNumberTips) && _unref(member).id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(remainingNumberTips)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(barcodes), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "item"
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(index + 1) + ". ", 1),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_b_form_input, {
                  modelValue: _unref(barcodes)[index],
                  "onUpdate:modelValue": ($event: any) => ((_unref(barcodes)[index]) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_AppScanner, {
                onChange: ($event: any) => (handleBarcodeChange(index, $event as any))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppIconScan)
                ]),
                _: 2
              }, 1032, ["onChange"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "more-button",
        onClick: handleAddMoreBarcode
      }, _toDisplayString(_unref(t)('offline_collection.form.Add more item')), 1)
    ]),
    _createElementVNode("div", {
      class: "submit-button",
      onClick: handleSubmit
    }, _toDisplayString(_unref(t)('Submit')), 1)
  ]))
}
}

})